import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header.component';
import { PipesModule } from '../../pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [PageHeaderComponent],
  imports: [
    CommonModule,
    PipesModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
  ],
  exports: [PageHeaderComponent],
})
export class PageHeaderModule {}
